import React from "react";
import { useNavigate } from "react-router-dom";

function useInterviewSubmitReviewSuccess() {

    const navigate = useNavigate()

  const onGoToHomeClick = () => {
      navigate('/dashboard')
  };

  const onAssessmentKitsClick = () => {
      navigate('/assigned-assessment-kits')
  };

  return {
      onAssessmentKitsClick,
      onGoToHomeClick
  };
}

export default useInterviewSubmitReviewSuccess;
